const accountsView = {
  title: 'Cuentas',
  toolbar: {
    create: 'Nueva Cuenta',
    search: 'Buscar cuentas...',
    delete: 'Eliminar',
    filterType: 'Buscar tipos...',
  },
  table: {
    aria: 'Lista de Cuentas',
    columns: {
      id: 'ID',
      name: 'Nombre de Cuenta',
      type: 'Tipo',
      email: 'Correo Electr\u00f3nico',
      phone: 'Tel\u00e9fono',
      relationship: 'Relaci\u00f3n',
      tradeVolume: 'Volumen Comercial',
    },
    actions: {
      viewDetails: 'Ver Detalles',
      edit: 'Editar',
    },
  },
  content: {
    error: 'Error al cargar cuentas: {{message}}',
    noData: 'No hay cuentas disponibles',
  },
  form: {
    sections: {
      accountDetails: 'Detalles de la Cuenta',
      primaryAddress: 'Direcci\u00f3n Principal',
      addresses: 'Direcciones y Contactos',
      contacts: 'Contactos',
    },
    fields: {
      name: 'Nombre de Cuenta',
      email: 'Correo Electr\u00f3nico',
      phone: 'N\u00famero de Tel\u00e9fono',
      website: 'URL del Sitio Web',
      type: 'Tipo de Cuenta',
      notes: 'Notas',
      relationship: 'Relaci\u00f3n Comercial',
      isCustomer: 'Cliente',
      isSupplier: 'Proveedor',
      accountManagers: 'Gestores de Cuentas',
      address: {
        type: 'Tipo de Direcci\u00f3n',
        types: {
          standard: 'Est\u00e1ndar',
          nonStandard: 'No Est\u00e1ndar',
          poBox: 'Apartado Postal',
        },
        name: 'Nombre',
        addressName: 'Nombre de direcci\u00f3n',
        streetAddress: 'Direcci\u00f3n de calle',
        streetAddressPlaceholder: 'Ej. Suite 100, Edificio A',
        addressLine2: 'Direcci\u00f3n L\u00ednea 2',
        addressLine2Placeholder: 'Apto, Suite, Unidad, etc.',
        poBoxNumber: 'N\u00famero de Apartado Postal',
        city: 'Ciudad',
        state: 'Estado / Provincia',
        postalCode: 'C\u00f3digo postal',
        country: 'Pa\u00eds',
        selectCountry: 'Seleccionar pa\u00eds',
        isMailingAddress: 'Direcci\u00f3n de correo',
        addAddress: 'Agregar Direcci\u00f3n',
        noAddresses: 'A\u00fan no se han agregado direcciones',
        namePlaceholder: 'Ej. Oficina Principal, Sede',
      },
      contacts: {
        title: 'Contactos',
        addContact: 'Agregar Contacto',
        removeContact: 'Eliminar Contacto',
        fullName: 'Nombre Completo',
        firstName: 'Nombre',
        lastName: 'Apellido',
        addressAs: 'Dirigirse Como',
        email: 'Correo Electr\u00f3nico',
        phone: 'Tel\u00e9fono',
        role: 'Cargo',
        department: 'Departamento',
        notes: 'Notas',
        isPrimary: 'Es principal',
        primaryBadge: 'Principal',
        noContacts: 'A\u00fan no se han agregado contactos',
        new: 'Nuevo',
        qualified: 'Calificado',
        contacted: 'Contactado',
        unqualified: 'No Calificado',
        customer: 'Cliente',
        lost: 'Perdido',
        formerCustomer: 'Ex Cliente',
        inactive: 'Inactivo',
      },
    },
    placeholders: {
      companyName: 'Nombre de empresa o persona',
      email: 'correo@ejemplo.com',
      phone: '+1 (555) 123-4567',
      website: 'https://ejemplo.com',
      accountManagers: 'Seleccionar gestores de cuentas',
      notes: 'Agregar notas sobre esta cuenta...',
      addressName: 'Ej. Sede, Almac\u00e9n',
    },
    type: {
      commercial: 'Comercial',
      individual: 'Individual',
    },
    validation: {
      required: 'Este campo es obligatorio',
      invalidEmail: 'Ingrese un correo electr\u00f3nico v\u00e1lido',
      invalidPhone: 'Ingrese un n\u00famero de tel\u00e9fono v\u00e1lido',
      invalidUrl: 'Ingrese una URL v\u00e1lida',
      invalidRelationship: 'Seleccione al menos un tipo de relaci\u00f3n',
    },
  },
  relationship: {
    customer: 'Cliente',
    supplier: 'Proveedor',
    carrier: 'Transportista',
  },
  deleteDialog: {
    titleSingle: (name: string) => `\u00bfEliminar ${name}?`,
    titleBatch: (count: number) =>
      `\u00bfEliminar ${count} ${count === 1 ? 'cuenta' : 'cuentas'}?`,
    cascadeWarning:
      'Esto tambi\u00e9n eliminar\u00e1 todos los contactos y direcciones asociados. Esta acci\u00f3n no se puede deshacer.',
  },
  dialog: {
    title: {
      create: 'Nueva Cuenta',
      edit: 'Editar Cuenta',
    },
    actions: {
      save: 'Guardar',
      create: 'Crear',
      cancel: 'Cancelar',
    },
  },
  addresses: {
    dialog: {
      titleEdit: 'Editar Direcci\u00f3n',
      titleNew: 'Nueva Direcci\u00f3n',
    },
    search: 'Buscar',
    noAddressesFound: 'No se encontraron direcciones',
  },
  contacts: {
    dialog: {
      titleEdit: 'Editar Contacto',
      titleNew: 'Nuevo Contacto',
    },
  },
  details: {
    inviteCustomer: 'Invitar Cliente',
    edit: 'Editar',
    inviteSentSuccess: (email: string) =>
      `Invitaci\u00f3n de cliente enviada exitosamente a ${email}`,
    inviteAlreadyLinked:
      'Este cliente ya ha sido invitado o ya est\u00e1 vinculado a una organizaci\u00f3n',
    inviteNoEmail:
      'Esta cuenta necesita una direcci\u00f3n de correo electr\u00f3nico para enviar una invitaci\u00f3n',
    inviteFailed: 'Error al enviar la invitaci\u00f3n al cliente',
  },
  messages: {
    createSuccess: 'Cuenta creada exitosamente',
    updateSuccess: 'Cuenta actualizada exitosamente',
    deleteSuccess: 'Cuenta(s) eliminada(s) exitosamente',
    validation: 'Por favor, corrija los errores en el formulario.',
    error: 'Ocurri\u00f3 un error al procesar su solicitud',
  },
  trade: {
    paymentTerms: 'T\u00e9rminos de Pago Predeterminados',
    purchasePaymentTerm: 'T\u00e9rmino de Pago de Compra',
    salesPaymentTerm: 'T\u00e9rmino de Pago de Venta',
    selectPaymentTerm: 'Seleccionar t\u00e9rmino de pago...',
    edit: 'Editar',
  },
  emptyState: {
    title: 'No se encontraron cuentas',
    description:
      'Intente ajustar su b\u00fasqueda o filtros para encontrar lo que busca.',
  },
};

const counterpartyGroups = {
  title: 'Grupos de Listas de Precios',
  addToGroup: 'Agregar a Grupo',
  remove: 'Eliminar',
  emptyState: 'Esta cuenta no está asignada a ningún grupo de contrapartes.',
  toast: {
    addSuccess: 'Cuenta agregada al grupo de contrapartes',
    addError: (message: string) =>
      `Error al agregar cuenta al grupo: ${message}`,
    removeSuccess: 'Cuenta eliminada del grupo de contrapartes',
    removeError: (message: string) =>
      `Error al eliminar cuenta del grupo: ${message}`,
  },
};

export const es = {
  accountsView,
  counterpartyGroups,
};
